// this component use to event reload after section rendering in upsell
class EventUpsell extends HTMLElement {
    constructor() {
      super();
      this.nextUpsell = this.nextUpsell.bind(this);
      this.prevUpsell = this.prevUpsell.bind(this);
      this.disableButton = this.disableButton.bind(this);
    }
  
    /**
     * Handles the initialization of a price range custom element and its associated functionality.
     *
     * @function
     */
    connectedCallback() {
  
      
        if (this.querySelector('.arrow-prev')) {
          this.querySelector('.arrow-prev').addEventListener('click', this.prevUpsell)
        }
    
        if (this.querySelector('.arrow-next')) {
          this.querySelector('.arrow-next').addEventListener('click', this.nextUpsell)
        }
    
        setTimeout(() => {
    
          this.disableButton(true);
        },300)
  
    }
  
    disableButton(isTrue) {
  
      const swiperEl = this.querySelector('swiper-container');
      const shadow = swiperEl.shadowRoot;
      const internalPrev = shadow.querySelector('.swiper-button-prev');
      const internalNext = shadow.querySelector('.swiper-button-next');
  
      internalPrev.style.display = 'none';
      internalNext.style.display = 'none';
  
      const buttonPrev = this.querySelector('.arrow-prev');
      const buttonNext = this.querySelector('.arrow-next');
  
      if (swiperEl.querySelectorAll('swiper-slide').length === 1) {
        buttonPrev.classList.add('disabled');
        buttonNext.classList.add('disabled');
        return;
      }
  
      if (internalPrev.classList.contains('swiper-button-disabled') || isTrue) {
  
        buttonPrev.classList.add('disabled');
        buttonNext.classList.remove('disabled');
        return
      }
      if (internalNext.classList.contains('swiper-button-disabled')) {
        buttonPrev.classList.remove('disabled');
        buttonNext.classList.add('disabled');
        return
      }
  
      buttonPrev.classList.remove('disabled');
      buttonNext.classList.remove('disabled');
  
    }
  
    nextUpsell() {
      const swiperEl = document.querySelector('swiper-container');
      swiperEl.swiper.slideNext();
  
      this.disableButton();
  
    }
  
    prevUpsell() {
      const swiperEl = document.querySelector('swiper-container');
      swiperEl.swiper.slidePrev();  
      this.disableButton();
    }
  
   
  
  }
  
  customElements.define('event-upsell', EventUpsell);
  